import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pageHeading: {
		id: 'business-form.form-submission.page-heading',
		defaultMessage: 'Form submission',
		description: 'Heading of the form submission page',
	},
});
